import createRestfulModule from "./restful-module";
import { actionClient } from "@/api";

export default createRestfulModule({
  state: {
    path: "member/personal/address", // 资源路径
    defaultRels: [], // 默认需要的关联数据
  },

  actions: {
    async updateCartItem(_, params) {
      return await actionClient.post("member/personal/flow", params);
    },
  },
});
